import { bindArray } from "./bindArray.js";
import { bindString } from "./bindString.js";
import { bindLinq } from "./bindLinq.js";
export const initializeLinq = () => {
    bindLinq(Map);
    bindLinq(Set);
    bindString();
    bindArray(Array);
    bindArray(Int8Array);
    bindArray(Int16Array);
    bindArray(Int32Array);
    bindArray(Uint8Array);
    bindArray(Uint8ClampedArray);
    bindArray(Uint16Array);
    bindArray(Uint32Array);
    bindArray(Float32Array);
    bindArray(Float64Array);
};
